import { PaymentTypeEnum, WebPaymentTypeEnum } from '@up/data';

export type PaymentReferenceType = {
  paymentType: PaymentTypeEnum;
  referenceId?: number;
  webPaymentType?: WebPaymentTypeEnum;
};
